import { endpoints } from "../helper/endpoints";
import jwtInterceptor from "../helper/jtwInterceptor"

/**
 * Function to register a user with a provided username and password.
 * @param {any} email - The email of the user.
 * @param {any} password - The password of the user.
 * @returns {Promise} A Promise that resolves with the register response data if successful or rejects with an error.
 */
export const register = async (email: string, password: string) => {
    return await jwtInterceptor.post(
        endpoints.REGISTER,
        // "https://dimsuat6.deltainsurance.co.nz/TestBPWebAPI/Register",
        JSON.stringify({ email: email, username: email, password: password, }),
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
    ).then((res: any) => {
        // console.log(res);
        return res.data;
    }).catch(error => {
        // Log an error message and return the error
        console.log("Registration error", error);
        return error;
    });
};

/**
 * Function to activate a user with the provided email.
 * @param {any} email - The email of the user.
 * @returns {Promise} A Promise that resolves with the activation response data if successful or rejects with an error.
 */
 export const activateUser = async (email: string) => {
  return await jwtInterceptor.post(
      endpoints.ACTIVATE,
      // "https://dimsuat6.deltainsurance.co.nz/TestBPWebAPI/Activate",
      JSON.stringify(email),
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
  ).then((res: any) => {
    //   console.log(res);
      return res.data;
  }).catch(error => {
      // Log an error message and return the error
      console.log("Activation error", error);
      return error;
  });
};


/**
 * Function to deactivate a user with the provided email.
 * @param {any} email - The email of the user.
 * @returns {Promise} A Promise that resolves with the deactivation response data if successful or rejects with an error.
 */
 export const deactivateUser = async (email: string) => {
  return await jwtInterceptor.post(
      endpoints.DEACTIVATE,
      // "https://dimsuat6.deltainsurance.co.nz/TestBPWebAPI/Inactivate",
      JSON.stringify(email),
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
  ).then((res: any) => {
    //   console.log(res);
      return res.data;
  }).catch(error => {
      // Log an error message and return the error
      console.log("Deactivation error", error);
      return error;
  });
};